<template>
    <div class="text-center mt-9">
        <div>
            <i class="bi bi-x-octagon-fill text-danger" style="font-size: 100px;"></i>
        </div>
        <div>
            <h3>{{ texts.accessForbidden }}</h3>
        </div>
        <div>
            <h6>{{ texts.permissionDenied }}</h6>
            <h6>{{ texts.checkCredentials }}</h6>
        </div>
    </div>
</template>
<script>
import 'bootstrap-icons/font/bootstrap-icons.css';

const translations = {
    az: {
        accessForbidden: 'Giriş qadağandır',
        permissionDenied: 'Sizin bu səhifəyə baxmaq icazəniz yoxdur.',
        checkCredentials: 'Lütfən, etimadnamənizi yoxlayın və lazım gələrsə sistem administratoru ilə əlaqə saxlayın.'
    },
    en: {
        accessForbidden: 'Access Forbidden',
        permissionDenied: 'You do not have permission to view this page.',
        checkCredentials: 'Please check your credentials and contact the system administrator if necessary.'
    },
    ru: {
        accessForbidden: 'Доступ запрещен',
        permissionDenied: 'У вас нет разрешения на просмотр этой страницы.',
        checkCredentials: 'Пожалуйста, проверьте ваши учетные данные и при необходимости свяжитесь с системным администратором.'
    },
    tr: {
        accessForbidden: 'Erişim Yasak',
        permissionDenied: 'Bu sayfayı görüntüleme izniniz yok.',
        checkCredentials: 'Lütfen kimlik bilgilerinizi kontrol edin ve gerekirse sistem yöneticisiyle iletişime geçin.'
    }
};

export default {
    computed: {
        currentLanguage() {
            const saved = localStorage.getItem('app_language');
            return saved && ['az', 'en', 'ru', 'tr'].includes(saved) ? saved : 'az';
        },
        texts() {
            return translations[this.currentLanguage] || translations.az;
        }
    }
}
</script>